import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW6500Component } from './kymw6500.component';
import { KYMW6501InputModel } from '../kymw6501/vo/kymw6501-input.model';
import { Point } from '@grapecity/wijmo';

/**
 * ECタイムセールマスタ一覧画面の値を管理するクラス
 *
 * @export KYMW6500Model
 * @class KYMW6500Model
 */

export class KYMW6500Model {

  kymw6500Component: KYMW6500Component;

  // タイムセールマスタ一覧データ
  public timeSaleList: Array<any> = new Array<any>();
  // ソートキー
  public sortKey: string = <string>'';
  // ソート順
  public sortOrder: string = <string>'';
  // 選択行
  public selectedRow: number = <number>0;
  // スクロール位置
  public scrollPosition: Point = new Point;
  // ファイル名
  public fileName: string = <string>'';

  // バインド用変数
  public orderCodeFr: string = <string>'';
  public orderCodeTo: string = <string>'';
  public categoryCode: string = <string>'';


  /**
   * タイムセールマスタ情報VO取得
   */
  public getTimeSaleDataVO(): any {
    // タイムセールマスタ情報VO
    const vo = {
      selectedOrderCode: '',
      selectedCategoryCode: '',
      orderCodeFr: '',
      orderCodeTo: '',
      categoryCode: ''
    };

    // タイムセールマスタ情報VOの初期化
    vo.orderCodeFr = this.kymw6500Component.kymw6500Model.orderCodeFr;          // 受注コード(FROM)
    if (!PlessViewUtilsSub.isEmpty(this.kymw6500Component.kymw6500Model.orderCodeTo)) {
      vo.orderCodeTo = this.kymw6500Component.kymw6500Model.orderCodeTo;        // 受注コード(TO)
    } else {
      // 受注コード(TO)が未入力の場合は受注コード(FROM)をセットする
      vo.orderCodeTo = this.kymw6500Component.kymw6500Model.orderCodeFr;        // 受注コード(TO)
    }
    vo.categoryCode = this.kymw6500Component.kymw6500Model.categoryCode;        // カテゴリコード

    // タイムセールマスタ情報VOを返却
    return vo;
  }

  /**
   * 検索結果の画面反映
   */
  public setDisplayResult(serverData: any): void {

    // 検索結果を変換
    const templist = serverData;

    // 「カテゴリコード：名称」を追加
    for (let i = Number(0); i < templist.length; i++) {
      templist[i].CategoryCodeName = templist[i].CategoryCode + ':' + templist[i].CategoryName;
    }
    this.timeSaleList = templist;

    // タイムセールマスタ一覧の有効化
    this.kymw6500Component.dtg_TimeSaleList.imeEnabled = true;
  }

  /**
   * タイムセールマスタ設定画面Input用VO取得
   */
  public getKYMW6501InputVO(procesDiv: string): any {
    // 変数定義
    const vo: KYMW6501InputModel = new KYMW6501InputModel();                    // タイムセールマスタ設定画面Input用VO

    // 処理区分のチェック
    if (KYMW6501InputModel.PROCES_DIV_UPDATE === (procesDiv)) {                 // 「2:更新」の場合
      // タイムセールマスタ設定画面Input用VOの初期化
      vo.ProcesDiv = KYMW6501InputModel.PROCES_DIV_UPDATE;                                                          // 処理区分(2:更新)
      vo.OrderCode = PlessViewUtilsSub.isEmptyArray(this.timeSaleList)
        ? '' : this.timeSaleList[this.selectedRow].OrderCode;        // 受注コード
      vo.CategoryCode = PlessViewUtilsSub.isEmptyArray(this.timeSaleList)
        ? '' : this.timeSaleList[this.selectedRow].CategoryCode;  // カテゴリコード
    } else {                                                                    // 上記以外の場合
      // タイムセールマスタ設定画面Input用VOの初期化
      vo.ProcesDiv = KYMW6501InputModel.PROCES_DIV_REGIST;                      // 処理区分(1:登録)
    }

    // タイムセールマスタ設定画面Input用VOを返却
    return vo;
  }

  /**
   * ファイル名を更新する
   *
   * @param serverData ファイル名のサーバ取得データ
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }

}
